<template>
  <div class="index">
    <div class="top">
      <img src="./img/top.jpg" alt="" />
      <div class="text-box">
        <div class="left">地图能力</div>
      </div>
      <ul class="ul">
        <li class="li" v-for="(item, index) in list" :key="index" @click="jump(item)" :class="route === item.route ? 'checked' : ''">
          <div class="li-text">
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {},
  data() {
    return {
      list: [
        {
          name: '二三维一体化',
          route: '/ability/integrated'
        },
        {
          name: '三维地图',
          route: '/ability/threeDimensional'
        },
        {
          name: '2.5维地图',
          route: '/ability/tfDimensional'
        },
        {
          name: '二维地图',
          route: '/ability/twoDimensional'
        },
        {
          name: '倾斜摄影',
          route: '/ability/tiltPhotography'
        }
      ]
    };
  },
  computed: {
    route() {
      return this.$route.path;
    }
  },
  watch: {},
  methods: {
    jump(item) {
      let { fullPath } = this.$route;
      if (!item.route) {
        return;
      }
      if (fullPath === item.route) {
        return;
      }
      this.$router.push({
        path: item.route
      });
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.index {
  .top {
    position: relative;
    img {
      // height: 710px;
      width: 100%;
      height: 710px;
    }
    .text-box {
      width: 566px;
      color: #fff;
      font-size: 70px;
      position: absolute;
      top: 40%;
      left: 55%;
      transform: translate(-50%, -50%);
      .left {
        text-align: left;
      }
      .bottom {
        margin-left: 60px;
        margin-top: 50px;
        font-size: 28px;
      }
    }
    .ul {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 98px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .li {
        font-size: 28px;
        cursor: pointer;
        color: #fff;
        font-family: 'PingFang';
        &:hover {
          color: #f15030;
        }
      }
      .checked {
        .li-text {
          color: #f15030;
        }
        &::before {
          width: 100%;
        }
      }
    }
  }
}
</style>
